module.exports = __webpack_public_path__ + "static/media/VIDDYOZE-Delivery.c6e7d9e7.mp4";